import React, { ReactElement, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Table, Button, Modal } from 'antd'
import type { TableColumnsType } from 'antd'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import type { ILogResData } from '@/store/models/tableEdit.model'
import { viewHistory } from '@/services/table.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { getUuid } from '@/utils/util'
// import { IAppState } from '@/store/reducers'

interface ExpandedDataType {
    key: React.Key
    date: string
    name: string
}

export default function LogListPop ( { recordId, tableParam, setViewLogId }: { 
    recordId: number | null, tableParam: string, setViewLogId: any
}): ReactElement {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [logLoading, setLogLoading] = useState(false)
    const [tableKey, setTableKey] = useState('a')
    const [curLogList, setCurLogList] = useState<{
        key: number
        after: string | any[]
        before: string | any[]
        field: string
    }[]>([])
    const [winH, setWinh] = useState<number>(0)
    
    // const dicClassList = useSelector((state: IAppState) => state.tableEditData.dicClass)

    const viewLogList = async (id: number, table: string) => {
        setIsModalOpen(true)
        setLogLoading(true)
        try {
            const { content }: { content: ILogResData[] } = await viewHistory({
                id,
                table
            }) as { content: ILogResData[] }
            setLogLoading(false)
            const logData: any[] = []
            content.map(log => {
                const result = JSON.parse(log.details).map((logItem: any) => ({
                    key: getUuid(8),
                    creator: log.creator,
                    modifyTime: moment(log.modifyTime).format('YYYY-MM-DD HH:mm:ss'),
                    field: logItem.field,
                    before: logItem.before,
                    after: logItem.after,
                }))
                Array.prototype.push.call(logData, ...result)
                return result
            })
            console.log('logData: ', logData)
            setCurLogList(logData)
            setTableKey(getUuid(8))
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
            setLogLoading(false)
        }
    }
    const closePop = () => {
        setIsModalOpen(false)
        setViewLogId(null)
    }
    const columns = [
        {
            title: t('field'),
            dataIndex: 'field',
            width: '10%',
            render(value: string) {
                const names = [t('techYearQuarters'), t('quantitativeIndicators'), t('buStakeholder'), t('tmtApproval'), t('maturity'), t('requirementSource'), t('Tech Name'), t('description'),
                    t('resourceNeeded'), t('toolsEquipment'), t('developedBy'), t('priority'), t('techLevel'), t('subsidiary'), t('researchForms'), t('PTN'),
                    t('techClass'), t('phases')]
                const fields = ['techYearQuarters', 'quantitativeIndicators', 'buStakeholder', 'tMTApproval', 'maturity', 'requirementSource', 'techName', 'description',
                    'resourceNeeded', 'toolsEquipment', 'developedBy', 'priority', 'techLevel', 'subsidiary', 'researchForms', 'techPtn',
                    'techClassId', 'phases']
                return <p>{names[fields.indexOf(value)]}</p>
            }
        },
        {
            title: t('before'),
            dataIndex: 'before',
            width: '30%',
            render(value: any) {
                if (Object.prototype.toString.call(value) === '[object Array]') {
                    return ''
                } else if (value && typeof value !== 'number' && value.includes('{"str":')) {
                    return <div dangerouslySetInnerHTML={{ __html: JSON.parse(value).str }}></div>
                    // const descriptionValue = JSON.parse(value).obj
                    // const setDescriptionValue = () => {
                    //     console.log('setDescriptionValue')
                    // }

                    // return <ConfigProvider
                    //     value={{
                    //         ...defaultConfig,
                    //         plugins: [
                    //             ...Object.values({
                    //                 ...plugs
                    //             }), 
                    //         ],
                    //     }}
                    // >
                    //     <DSlate className="editor_view" value={descriptionValue} onChange={setDescriptionValue} />
                    // </ConfigProvider>
                } else if (value && typeof value !== 'number' && (value.includes('div') || value.includes('span'))) {
                    return <div dangerouslySetInnerHTML={{ __html: value }}></div>
                } else {
                    return value ?? ''
                }
            },
        },
        {
            title: t('after'),
            dataIndex: 'after',
            width: '30%',
            render (value: any) {
                if (Object.prototype.toString.call(value) === '[object Array]') {
                    return ''
                } else if (value && typeof value === 'string' && value.includes('{"str":')) {
                    return <div dangerouslySetInnerHTML={{ __html: JSON.parse(value).str }}></div>
                } else if (value && typeof value === 'string' && (value.includes('div') || value.includes('span'))) {
                    return <div dangerouslySetInnerHTML={{ __html: value }}></div>
                } else {
                    return value ?? ''
                }
            },
        },
        {
            title: t('modifyTime'),
            dataIndex: 'modifyTime',
            width: '10%',
        },
        {
            title: t('updator'),
            dataIndex: 'creator',
            width: '20%',
        }
    ]

    const rowExpandable = (record: any) => {
        return Object.prototype.toString.call(record.before) === '[object Array]' || Object.prototype.toString.call(record.after) === '[object Array]'
    }
    const expandedRowRender = (record: any) => {
        // console.log('expandedRowRender record:', record, index, indent, expanded)
        if (Object.prototype.toString.call(record.before) === '[object Array]') {
            record.before.sort((a: any, b: any) => a.id - b.id)
        }
        if (Object.prototype.toString.call(record.after) === '[object Array]') {
            record.after.sort((a: any, b: any) => a.id - b.id)
        }
        const beforeArr = record.before?.filter((item: any) => 'id' in item)
        const afterArr = record.after ? record.after.filter((item: any) => 'id' in item) : []
        const maxRowNum = Math.max(beforeArr?.length, afterArr.length)
        const arr: any[] = []
        for(let i = 0; i < maxRowNum; i++) {
            arr[i] = {
                key: 'row' + '-' + (record.before[0] ? record.before[0].id : (record.after[0] ? record.after[0].id : getUuid(8))) + '-' + i
            }
            if (record.before[i] && 'id' in record.before[i]) {
                arr[i].before = record.before[i]
            } else {
                arr[i].before = ''
            }
            if (record.after[i] && 'id' in record.after[i]) {
                arr[i].after = record.after[i]
            } else {
                arr[i].after = ''
            }
        }
        const columns: TableColumnsType<ExpandedDataType> = [
            {
                title: '',
                width: '10%',
                render() {
                    return <p>&nbsp;</p>
                }
            },
            {
                title: 'before',
                dataIndex: 'before',
                width: '30%',
                render(value: any) {
                    // const showStatus = dicClassList['status-year'].value
                    if (value) {
                        if (value.quarter) {
                            return <span>{value.year}{t('year')}{value.quarter}{t('quarter')}: {['PLAN', 'ON'][value.status - 1]}</span>
                        } else {
                            return <div>
                                <p>{value.year}{t('year')}: </p>
                                {value.techName && <p style={{ textIndent: '2em' }}>{t('Tech Name')}: {value.techName}</p>}
                                {value.techPtn && <p style={{ textIndent: '2em' }}>{t('PTN')}: {value.techPtn}</p>}
                                {value.projectInfo && <p style={{ textIndent: '2em' }}>{t('Project Info')}: {value.projectInfo}</p>}
                                {value.releaseStatus && <p style={{ textIndent: '2em' }}>{t('Release Status')}: {value.releaseStatus}</p>}
                            </div>
                        }
                    } else {
                        return ''
                    }
                },
            },
            {
                title: 'after',
                dataIndex: 'after',
                render(value: any) {
                    if (value) {
                        if (value.quarter) {
                            return <span>{value.year}{t('year')}{value.quarter}{t('quarter')}: {['PLAN', 'ON'][value.status - 1]}</span>
                        } else {
                            return <div>
                                <p>{value.year}{t('year')}: </p>
                                {value.techName && <p style={{ textIndent: '2em' }}>{t('Tech Name')}: {value.techName}</p>}
                                {value.techPtn && <p style={{ textIndent: '2em' }}>{t('PTN')}: {value.techPtn}</p>}
                                {value.projectInfo && <p style={{ textIndent: '2em' }}>{t('Project Info')}: {value.projectInfo}</p>}
                                {value.releaseStatus && <p style={{ textIndent: '2em' }}>{t('Release Status')}: {value.releaseStatus}</p>}
                            </div>
                        }
                    } else {
                        return ''
                    }
                },
            },
        ]
        return <Table bordered columns={columns} dataSource={arr} pagination={false} showHeader={false} />
    }

    useEffect(() => {
        setWinh(document.body.clientHeight - 300)
        window.onresize = () => {
            setWinh(document.body.clientHeight - 300)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (recordId && tableParam) {
            viewLogList(recordId, tableParam)
        }
    }, [recordId, tableParam])
    return (
        <Modal title={t('Modify Log')} visible={isModalOpen} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            footer={[
                <Button key="submit" type="primary" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            <Table key={tableKey} scroll={{ x: '100%', y: winH }} bordered
                dataSource={curLogList} 
                columns={columns}
                expandable={{ expandedRowRender, rowExpandable, defaultExpandAllRows: true }}
                loading={logLoading}
            />
        </Modal>
    )
}